import React, { PureComponent } from "react";
import { BarChart, Bar, XAxis, YAxis, Cell, LabelList, Tooltip as RechartsTooltip, ResponsiveContainer } from "recharts";
import { ChartContainer, ChartWrapper, TotalAudienceWrapper } from "./tinyChartBar.styles";
import { ReactComponent as CombinedAudienceIcon } from "../../Assets/audience.svg";

// Function to format values in millions (M) or thousands (K)
const formatValue = (value) => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${Math.floor(value / 1000)}K`;
  return value.toString();
};

export class TinyChartBar extends PureComponent {
  render() {
    const { data, stats } = this.props;  // Receive data and stats from props
    const sortedData = data.sort((a, b) => b.uv - a.uv);  // Sort the data by uv value
    const totalAudienceSize = sortedData.reduce((acc, item) => acc + item.uv, 0);  // Calculate total audience size
    
    // Extract statistics from props
    const { quantity_past_month, value_difference } = stats; 
    const value_quantity_past_month = parseFloat(quantity_past_month);
    const percentage = (100 / value_quantity_past_month) * Math.abs(value_difference);  
    const sign = value_difference > 0 ? '+' : value_difference < 0 ? '-' : '';  
    const formattedDifference = `${sign} ${formatValue(Math.abs(value_difference))} (${percentage.toFixed(2)}%)`; 

    return (
      <ChartContainer>
        <ChartWrapper>
          <ResponsiveContainer width="90%" height="100%">
            <BarChart 
              margin={{
                top: 5,
                right: 35,
                left: 20,
                bottom: 5,
              }} 
            data={sortedData} layout="vertical">
              <XAxis type="number" hide />
              <YAxis dataKey="name" type="category" tick={{ textAnchor: 'end', fontSize: 11 }} />
              <RechartsTooltip 
                formatter={(value) => [`${((value / totalAudienceSize) * 100).toFixed(1)}%`, '']} 
                cursor={{ fill: 'transparent' }} 
              />
              <Bar dataKey="uv" minPointSize={15} barSize={25}>
                {sortedData.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={
                      entry.name === 'Instagram' ? '#dd2a7b' :
                      entry.name === 'YouTube' ? '#fe0200' :
                      entry.name === 'Spotify' ? '#1cb955' :
                      entry.name === 'TikTok' ? '#000100' :
                      '#000'
                    } 
                  />
                ))}
                <LabelList 
                  dataKey="uv" 
                  position="right" 
                  formatter={(value) => `${((value / totalAudienceSize) * 100).toFixed(1)}%`} 
                  fill="#000" 
                  fontSize={12}
                  style={{ whiteSpace: 'nowrap' }} 
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartWrapper>
        <TotalAudienceWrapper>
          <div className="title">
            <CombinedAudienceIcon />
            <p>Combined Audience Size</p>
          </div>
          <p className="total">Total</p>
          <p className="number">{formatValue(totalAudienceSize)}</p>
          <p className="raised">{formattedDifference}</p>
        </TotalAudienceWrapper>
      </ChartContainer>
    );
  }
}

export default TinyChartBar;